// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from '../../../node_module_clones/recompose';

// Utils
import { isPlatformIframe } from '../../platform/utils/platformDetailsUtils';

// Components
import dontUpdateForKeys from '../../utils/milanoteRecompose/dontUpdateForKeys';
import WorkspaceToolsHeader from './workspaceToolsHeader/WorkspaceToolsHeader';
import CurrentBoardHeader from './currentBoardHeader/CurrentBoardHeader';

// Selectors
import { getIsUtilPopupOpened } from './utilPopupSelector';
import { detachedBreadcrumbIsValidSelector } from '../breadcrumbs/breadcrumbSelector';
import { isPublishPreviewModeEnabledSelector } from '../preview/previewSelector';
import { isPresentationModeEnabledSelector } from '../presentation/presentationSelector';
import { boardSearchPopupEnabledSelector } from './workspaceToolsHeader/boardSearch/state/boardSearchPopupSelector';
import { getIsUndoRedoButtonsSettingEnabled } from '../../user/currentUserSelector';
import { getPlatformDetailsSelector } from '../../platform/platformSelector';
import { getIsSidebarPrototypeEnabled } from '../sidebar/sidebarSelector';

// Styles
import './AppHeader.scss';

const mapStateToProps = createStructuredSelector({
    utilPopupOpened: getIsUtilPopupOpened,
    detachedBreadcrumbIsValid: detachedBreadcrumbIsValidSelector,
    isPublishPreviewMode: isPublishPreviewModeEnabledSelector,
    isPresentationMode: isPresentationModeEnabledSelector,
    isBoardSearchEnabled: boardSearchPopupEnabledSelector,
    isUndoRedoButtonsSettingEnabled: getIsUndoRedoButtonsSettingEnabled,
    platformDetails: getPlatformDetailsSelector,
    isSidebarProtypeEnabled: getIsSidebarPrototypeEnabled,
});

const enhance = compose(dontUpdateForKeys(['isDragging']), connect(mapStateToProps));

const AppHeader = (props) => {
    const {
        breadcrumbObj,
        isGuest,
        isPublishPreviewMode,
        detachedBreadcrumbIsValid,
        isCurrentBoardRoot,
        platformDetails,
    } = props;

    const isLoadingBreadcrumbs = breadcrumbObj.detached && !detachedBreadcrumbIsValid;

    return (
        <header className="AppHeader">
            {!isPublishPreviewMode && !isGuest && !isPlatformIframe(platformDetails) && (
                <WorkspaceToolsHeader {...props} isLoadingBreadcrumbs={isLoadingBreadcrumbs} />
            )}

            {!isCurrentBoardRoot && <CurrentBoardHeader {...props} isLoadingBreadcrumbs={isLoadingBreadcrumbs} />}
        </header>
    );
};

AppHeader.propTypes = {
    isGuest: PropTypes.bool,
    isPublishPreviewMode: PropTypes.bool,
    isCurrentBoardRoot: PropTypes.bool,
    detachedBreadcrumbIsValid: PropTypes.bool,
    breadcrumbObj: PropTypes.object,
    isPresentationMode: PropTypes.bool,
    isBoardSearchEnabled: PropTypes.bool,
    platformDetails: PropTypes.object,
    isSidebarProtypeEnabled: PropTypes.bool,
};

export default enhance(AppHeader);
